<template>
    <textfield-screen
            id="firstName"
            :title="$ml.get('setLastNameReg')"
            v-model="text"
            :is-not-valid="isNotValid"
            :is-not-valid-message="isNotValidMessage"
            :maxlength="30"
            :headerImg="3"
            :disabledNextButton="disabled"
            @next="nextScreen"
            @back="back"
    ></textfield-screen>
</template>

<script>
    import Vue from 'vue'
    import TextfieldScreen from "../../../components/layout/textfield-screen";
    import {default as Profile, filteredName, isWrongName} from "../../../helpers/profile";

    export default {
        name: "setLastName",
        components: {TextfieldScreen},
        data() {
            return {
                isNotValid: false,
                isNotValidMessage: this.$ml.get('setNameErrorMessage'),
                text: Profile.lastName,
            }
        },
        created() {
            let isMobile = window.innerWidth < 600;
            if (!isMobile) {
                if (Profile.process === 'accessRecovery')
                    this.$router.replace({ name: 'AccessRecoveryFio'});
                else
                    this.$router.replace({ name: 'RegistrationFio'});
            }
        },
        watch: {
            text: function (val) {
                Vue.nextTick(() => {
                    this.text = filteredName(val);
                });
            },
        },
        computed: {
            disabled: function () {
                return this.text.trim().length === 0
            }
        },
        methods: {
            nextScreen: function () {
                if (!this.text.trim())
                    return;
                if (isWrongName(this.text)) {
                    this.isNotValid = true;
                    setTimeout(()=>{
                        this.isNotValid = false;
                    }, 2500);
                    return;
                }
                Profile.setData({lastName: this.text});
                if (Profile.process === 'accessRecovery')
                    this.$router.push({ name: 'AccessRecoveryFirstName'});
                else
                    this.$router.push({ name: 'RegistrationFirstName'});
            },
            back: function () {
                this.$router.back();
            }
        },
    }
</script>

<style scoped>

</style>